import type { z } from "zod";

import { zOutSchema2 } from "./common";

import { Pagination } from "~/shared/zod";

const zOut = Pagination.Page.zSchema(zOutSchema2);
type Out = z.infer<typeof zOut>;

export { zOut };
export type { Out };
